<template>
  <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
    <div class="modal-content" @click="closeModal">
      <span class="close-button" @click="closeModal">&times;</span>
      <img src="@/assets/Group 69.png" alt="成功图标" class="success-icon" />
      <h2>信用卡免費停車折抵成功</h2>
      <p>本次免費停車折抵成功<br />將重新回到折抵繳費頁面</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: true
    };
  },
  methods: {
    closeModal() {
      this.showModal = false;

      this.$emit('show-residual-fee');

    },
    showResidualFee() {
      this.$emit('show-residual-fee');
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  display: flex;
  flex-direction: column;
  align-items: center; /* 水平居中 */
  justify-content: center; /* 垂直居中 */
  background-color: white;
  border-radius: 10px;
  margin-top: 30vh;

  width: 480px;
  height: 400px;
  padding: 24px 30px;
  position: relative;
  text-align: center;
  box-sizing: border-box;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
  color: black;
}

.success-icon {
  width: 80px;
  height: 80px;
  margin-bottom: 20px;
}

h2 {
  font-size: 24px;
  color: var(--green03);
  font-weight: bold;
  margin-top: 0;
  margin-bottom: 10px;
}

p {
  font-size: 16px;
  color: #333;
  line-height: 1.5;
}

/* Responsive Styles */
@media (max-width: 560px) {
  .modal-content {
    width: 343px;
    height: auto;
  }

  h2 {
    font-size: 20px;
  }

  p {
    font-size: 14px;
  }
}
</style>
